/**
 * `?ask=` carries an ask the reader filled in elsewhere in the dashboard to the
 * Agent. `/dashboard/agent` opens a new thread with it, and the thread sends it
 * as its first message once, then drops it from the address bar so a reload or
 * a back button cannot send it twice.
 */
export const readAgentAsk = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const ask = value.trim();
  return ask === '' ? undefined : ask;
};
